import http from '../axios';

export function index(card_type = '', name = '') {
  const parts = [];
  if (card_type) {
    parts.push('card_type=' + encodeURIComponent(card_type));
  }
  if (name) {
    parts.push('name=' + encodeURIComponent(name));
  }
  const qs = parts.length ? '?' + parts.join('&') : '';
  return http.get('/cards' + qs);
}

export function getCard(cardId) {
  return http.get('/cards/' + cardId);
}

export function update(payload) {
  return http.patch(`/cards/${payload.id}`, payload);
}

export function create(payload){
  return http.post('/cards', payload);
}